import { Button } from "@egaranti/components";
import { Tag } from "@egaranti/components";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@egaranti/components";
import { TableSkeleton } from "@egaranti/components";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import useEmployeesStore from "@/stores/useEmployeesStore";

import EmptyTable from "@/components/shared/EmptyTable";
import CheckRole from "@/components/shared/checkRole";

const Employees = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { getEmployees, employees, loading } = useEmployeesStore();

  useEffect(() => {
    getEmployees();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="min-h-full bg-[#F9FAFC] p-4">
      <div className="flex items-center justify-end pb-4"></div>
      <div className="rounded-lg">
        <div className="mb-5 flex justify-end">
          <CheckRole section="PERSONALS" action="EDIT">
            <Button onClick={() => navigate("/settings/employees/create")}>
              {t("settingsPage.addEmployee")}
            </Button>
          </CheckRole>
        </div>
        <div className="flex flex-col rounded-t-lg bg-white pb-4">
          {loading ? (
            <>
              <div className="hidden md:block">
                <Table>
                  <TableSkeleton colSpan={4} />
                </Table>
              </div>
              <div className="flex flex-col divide-y divide-gray-100 md:hidden">
                {Array.from({ length: 6 }).map((_, i) => (
                  <PersonelKartiIskelet key={i} />
                ))}
              </div>
            </>
          ) : employees.length ? (
            <>
            {/*
              EPS-5120 (8. bulgu) — liste telefonda masaustu tablosunu aynen
              gosteriyordu. Replikada olculdu (390 px): 5 sutundan yalniz 2'si
              ekranda; E-posta, Durum ve Not sagda kaliyor, tablo 396 px yana
              kaydirilabiliyor. Bireysel Musteriler'de onaylanan desen uygulandi.
            */}
            <div className="hidden md:block">
            <Table>
              <TableHeader>
                <TableHead>{t("settingsPage.fullName")}</TableHead>
                <TableHead>{t("settingsPage.phone")}</TableHead>
                <TableHead>{t("settingsPage.email")}</TableHead>
                <TableHead>{t("settingsPage.status")}</TableHead>
                <TableHead>{t("settingsPage.note")}</TableHead>
              </TableHeader>
              <TableBody>
                {employees?.map((employee) => (
                  <TableRow
                    key={employee.id}
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/settings/employees/${employee.id}`)
                    }
                  >
                    <TableCell>
                      {employee.firstName} {employee.lastName}
                    </TableCell>
                    <TableCell>{employee.phone}</TableCell>
                    <TableCell>{employee.email}</TableCell>
                    <TableCell>
                      <Tag
                        size="sm"
                        variant={
                          employee.status === "WAITING_MERCHANT" ||
                          employee.status === "WAITING_CUSTOMER"
                            ? "yellow"
                            : "blue"
                        }
                      >
                        {employee.status === "ACTIVE" &&
                          t("settingsPage.active")}
                      </Tag>
                    </TableCell>
                    <TableCell>{employee.type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </div>

            {/* Mobil kart listesi */}
            <div className="flex flex-col divide-y divide-gray-100 md:hidden">
              {employees?.map((employee) => (
                <PersonelKartiMobil
                  key={employee.id}
                  employee={employee}
                  onClick={() => navigate(`/settings/employees/${employee.id}`)}
                  t={t}
                />
              ))}
            </div>
            </>
          ) : (
            <EmptyTable
              title={t("settingsPage.employeeCouldNotFound")}
              desc={t("settingsPage.employeeCouldNotFoundDesc")}
            />
          )}
        </div>
      </div>
    </main>
  );
};


/**
 * EPS-5120 (8. bulgu) — Personel listesinin mobil kart gorunumu.
 *
 * Tabloda 5 sutun var, 390 px'de yalniz 2'si goruluyordu. Kartta tum alanlar:
 * ad soyad (baslik), telefon, e-posta, not ve durum rozeti.
 */
const PersonelKartiMobil = ({ employee, onClick, t }) => (
  <div
    role="button"
    onClick={onClick}
    className="flex cursor-pointer flex-col gap-2 px-4 py-4 active:bg-[#F9FAFC]"
  >
    <div className="flex items-start justify-between gap-3">
      <span className="min-w-0 flex-1 truncate font-medium text-[#111729]">
        {employee.firstName} {employee.lastName}
      </span>
      <Tag
        size="sm"
        variant={
          employee.status === "WAITING_MERCHANT" ||
          employee.status === "WAITING_CUSTOMER"
            ? "yellow"
            : "blue"
        }
      >
        {employee.status === "ACTIVE" && t("settingsPage.active")}
      </Tag>
    </div>
    <dl className="space-y-0.5 text-sm text-[#677389]">
      <div className="flex gap-2">
        <dt className="shrink-0">{t("settingsPage.phone")}:</dt>
        <dd className="truncate">{employee.phone || "-"}</dd>
      </div>
      <div className="flex gap-2">
        <dt className="shrink-0">{t("settingsPage.email")}:</dt>
        <dd className="truncate">{employee.email || "-"}</dd>
      </div>
      <div className="flex gap-2">
        <dt className="shrink-0">{t("settingsPage.note")}:</dt>
        <dd className="truncate">{employee.type || "-"}</dd>
      </div>
    </dl>
  </div>
);

/** Kart yuksekligiyle ayni iskelet. */
const PersonelKartiIskelet = () => (
  <div className="flex flex-col gap-2 px-4 py-4">
    <div className="h-4 w-1/2 animate-pulse rounded bg-gray-200" />
    <div className="h-3 w-3/4 animate-pulse rounded bg-gray-100" />
    <div className="h-3 w-2/3 animate-pulse rounded bg-gray-100" />
    <div className="h-3 w-1/2 animate-pulse rounded bg-gray-100" />
  </div>
);

export default Employees;
